var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"add-truck"}},[_c('main',{staticStyle:{"text-align":"left","white-space":"normal"}},[_c('add-truck',{attrs:{"id":_vm.id},on:{"cancel":function($event){return _vm.$router.push('/trucks')},"save":function($event){return _vm.$router.push('/trucks')}}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ce4a18f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PageTruckSignUp.vue
// module id = null
// module chunks = 